import { toast, ToastContainer as ReactToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Configure default toast options
const defaultOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Toast notification methods
export const showToast = {
  success: (message, options = {}) => {
    return toast.success(message, { ...defaultOptions, ...options });
  },
  error: (message, options = {}) => {
    return toast.error(message, { ...defaultOptions, ...options });
  },
  info: (message, options = {}) => {
    return toast.info(message, { ...defaultOptions, ...options });
  },
  warning: (message, options = {}) => {
    return toast.warning(message, { ...defaultOptions, ...options });
  },
  default: (message, options = {}) => {
    return toast(message, { ...defaultOptions, ...options });
  },
};

// ToastContainer component to be rendered in App.js
const ToastContainer = () => {
  return (
    <div className="toast-container">
      <ReactToastifyContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default ToastContainer;
